import { IUserViewModel } from './../types/interfaces'
import { PermissionsEnum } from './../types/enums'

export class PermissionManager {
  public static hasPermission(user: { permissions?: string[] }, permission: PermissionsEnum): boolean {
    return !!user.permissions && user.permissions.indexOf(permission) >= 0
  }
  public static canViewReports(user: IUserViewModel) {
    if (user.isInternalUser) {
      return true
    }
    return PermissionManager.hasPermission(user, PermissionsEnum.ReportsView)
  }

  public static canApproveRequests(user: { permissions?: string[] }) {
    return PermissionManager.hasPermission(user, PermissionsEnum.RequestsApprove)
  }

  public static canViewCosts(user: IUserViewModel) {
    if (user.isInternalUser) {
      return true
    }
    return PermissionManager.hasPermission(user, PermissionsEnum.CostsView)
  }
}
